/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2015, 2017. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
/*eslint-env node*/
/*global module*/
"use strict";

// Clones a JSON-serializable object
module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};